import { validationRules, initializeFormValidation } from "packs/validator";
import { fetchAPI } from "packs/api";

document.addEventListener("DOMContentLoaded", () => {
  function applyValidation(formId, type) {
    const form = document.querySelector(formId);
    if (!form) return;

    // Clone and adjust validation rules locally
    const localRules = {
      ...validationRules,
      "user[password_confirmation]": {
        ...validationRules["user[password_confirmation]"],
        equalTo: type === "page" ? "user_password_page" : "user_password_modal"
      }
    };

    initializeFormValidation(form, localRules);
    monitorFormValidity(form);

    // Username validation with debounce
    form.querySelectorAll(`input[name="user[login]"]`).forEach((input) => {
      if (input.dataset.bound === "true") return;
      input.dataset.bound = "true";

      input.addEventListener("keyup", debounce(function () {
        const username = this.value.trim();
        const errorElement = form.querySelector("#sign_up_form_error_login");

        if (hasInvalidUsernameCharacters(username)) {
          showInlineError(errorElement, I18n.t("username_validation_msg"));
        } else if (looksLikeDomain(username)) {
          showInlineError(errorElement, I18n.t("username_domain_validation_msg"));
        } else if (username.length >= 3 && username.length <= 30) {
          validateUserName(username, this);
        }
      }, 300));
    });

    // Email validation with debounce
    form.querySelectorAll(`input[name="user[email]"]`).forEach((input) => {
      if (input.dataset.bound === "true") return;
      input.dataset.bound = "true";

      input.addEventListener("keyup", debounce(function () {
        const email = this.value.toLowerCase().trim();
        const errorElement = form.querySelector("#sign_up_form_error_email");

        if (isValidEmailFormat(email)) {
          validateEmail(email, this);
        }
      }, 300));
    });

    // Disable submit if form invalid on submit attempt
    form.addEventListener("submit", function (e) {
      if (!form.checkValidity()) {
        e.preventDefault();
        const submitBtn = form.querySelector('input[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
      }
    });
  }

  // Apply validation
  applyValidation("#sign_up_form_page", "page");
  applyValidation("#sign_up_form_modal", "modal");

  const forgotPasswordForm = document.querySelector("#forgot-password-form");
  if (forgotPasswordForm) {
    initializeFormValidation(forgotPasswordForm, {
      "email": validationRules["user[email]"]
    });
    monitorFormValidity(forgotPasswordForm);
  }

  const resetPasswordForm = document.querySelector(".edit_user");
  if (resetPasswordForm) {
    initializeFormValidation(resetPasswordForm, {
      "user[password]": validationRules["user[password]"],
      "user[password_confirmation]": {
        ...validationRules["user[password_confirmation]"],
        equalTo: "user_password"
      }
    });
    monitorFormValidity(resetPasswordForm);
  }
});

// --- API validation functions ---

function validateUserName(username, input) {
  const form = input.closest("form");
  const errorElement = form.querySelector("#sign_up_form_error_login");

  fetchAPI("/profile", "GET", { username }, "script")
    .then((data) => {
      if (data === "true") {
        showInlineError(errorElement, `${I18n.t("username_exist")}.`);
        input.dataset.apiError = "true";
      } else {
        hideInlineError(errorElement);
        input.dataset.apiError = "false";
      }
    })
    .catch((err) => console.error("Username check failed", err));
}

function validateEmail(email, input) {
  const form = input.closest("form");
  const errorElement = form.querySelector("#sign_up_form_error_email");

  fetchAPI("/profile", "GET", { email }, "script")
    .then((data) => {
      if (data === "true") {
        showInlineError(errorElement, `${I18n.t("email_exist")}.`);
        input.dataset.apiError = "true";
      } else {
        hideInlineError(errorElement);
        input.dataset.apiError = "false";
      }
    })
    .catch((err) => console.error("Email check failed", err));
}

// --- Helpers ---

function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function showInlineError(el, message) {
  if (el) {
    el.textContent = message;
    el.style.display = "block";
  }
}

function hideInlineError(el) {
  if (el) {
    el.textContent = "";
    el.style.display = "none";
  }
}

function isValidEmailFormat(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

function hasInvalidUsernameCharacters(str) {
  return /[^a-zA-Zа-яА-Я0-9._-]/.test(str);
}

function looksLikeDomain(str) {
  const parts = str.split(".");
  return ["com", "in", "net", "org"].includes(parts.at(-1));
}

// --- NEW: Monitor form validity and re-enable submit ---

function monitorFormValidity(form) {
  const submitBtn = form.querySelector('input[type="submit"]');
  if (!submitBtn) return;

  const checkAndEnable = () => {
    if (form.checkValidity()) {
      submitBtn.disabled = false;
    }
  };

  form.addEventListener("input", checkAndEnable);
  form.addEventListener("change", checkAndEnable);
}
